import React from 'react';
import './TopLinks.css';

export default function TopLinks() {
  return (
    <div className="TopLinks">
      <a href="https://movepump.com/token/0x250839eb4937b6041ae42f95e011e14c1f77730bb50d9575e486d13e67b93939::suuiii::SUUIII" className="TopLinkContainer" target="_blank" rel="noopener noreferrer">
        <span className="rotate-text">CHART</span>
      </a>
      <a href="https://t.me/Suuuuuuiiiiiiiiiil" className="TopLinkContainer" target="_blank" rel="noopener noreferrer">
        <span className="rotate-text">TELEGRAM</span>
      </a>
      <a href="https://x.com/SuiiiiiiOnSui" className="TopLinkContainer" target="_blank" rel="noopener noreferrer">
        <span className="rotate-text">X</span>
      </a>
    </div>
  );
}